
import Moderator from '@/models/bread/Moderator/playerMathPerformance'


export default {
  key:'MathPerformance',
  name:{
    singular:'Math Performance',
    plural:'Math Performances',
  },
  parents:[
    'Player',
  ],
  grandParents:[
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}